var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ comScrollBar: _vm.maisDeUmItem, semScrollbBar: !_vm.maisDeUmItem },style:(_vm.customStyle)},_vm._l((_vm.item.value),function(item){return _c('div',{key:item.id},[_c('v-chip',{attrs:{"small":""}},[_c('span',[_vm._v(_vm._s(item.nome))])])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }